import { __assign as t, __rest as I } from "./index11.js";
import { v4 as _ } from "./index44.js";
import { dset as y } from "./index45.js";
import E from "./index46.js";
var B = (
  /** @class */
  function() {
    function p(o) {
      this.user = o;
    }
    return p.prototype.track = function(o, n, i, r) {
      return this.normalize(t(t({}, this.baseEvent()), { event: o, type: "track", properties: n, options: t({}, i), integrations: t({}, r) }));
    }, p.prototype.page = function(o, n, i, r, s) {
      var e, a = {
        type: "page",
        properties: t({}, i),
        options: t({}, r),
        integrations: t({}, s)
      };
      return o !== null && (a.category = o, a.properties = (e = a.properties) !== null && e !== void 0 ? e : {}, a.properties.category = o), n !== null && (a.name = n), this.normalize(t(t({}, this.baseEvent()), a));
    }, p.prototype.screen = function(o, n, i, r, s) {
      var e = {
        type: "screen",
        properties: t({}, i),
        options: t({}, r),
        integrations: t({}, s)
      };
      return o !== null && (e.category = o), n !== null && (e.name = n), this.normalize(t(t({}, this.baseEvent()), e));
    }, p.prototype.identify = function(o, n, i, r) {
      return this.normalize(t(t({}, this.baseEvent()), { type: "identify", userId: o, traits: n, options: t({}, i), integrations: t({}, r) }));
    }, p.prototype.group = function(o, n, i, r) {
      return this.normalize(t(t({}, this.baseEvent()), { type: "group", traits: n, options: t({}, i), integrations: t({}, r), groupId: o }));
    }, p.prototype.alias = function(o, n, i, r) {
      var s = {
        userId: o,
        type: "alias",
        options: t({}, i),
        integrations: t({}, r)
      };
      return n !== null && (s.previousId = n), o === void 0 ? this.normalize(t(t({}, s), this.baseEvent())) : this.normalize(t(t({}, this.baseEvent()), s));
    }, p.prototype.baseEvent = function() {
      var o = {
        integrations: {},
        options: {}
      }, n = this.user;
      return n.id() && (o.userId = n.id()), n.anonymousId() && (o.anonymousId = n.anonymousId()), o;
    }, p.prototype.context = function(o) {
      var n, i, r, s = ["integrations", "anonymousId", "timestamp", "userId"], e = (n = o.options) !== null && n !== void 0 ? n : {};
      delete e.integrations;
      var a = Object.keys(e), v = (r = (i = o.options) === null || i === void 0 ? void 0 : i.context) !== null && r !== void 0 ? r : {}, d = {};
      return a.forEach(function(u) {
        u !== "context" && (s.includes(u) ? y(d, u, e[u]) : y(v, u, e[u]));
      }), [v, d];
    }, p.prototype.normalize = function(o) {
      var n, i, r;
      !((n = o.options) === null || n === void 0) && n.anonymousId && this.user.anonymousId(o.options.anonymousId);
      var s = Object.keys((i = o.integrations) !== null && i !== void 0 ? i : {}).reduce(function(b, m) {
        var l, c;
        return t(t({}, b), (l = {}, l[m] = !!(!((c = o.integrations) === null || c === void 0) && c[m]), l));
      }, {}), e = t(t({}, s), (r = o.options) === null || r === void 0 ? void 0 : r.integrations), a = this.context(o), v = a[0], d = a[1];
      o.options;
      var u = I(o, ["options"]), f = t(t(t({ timestamp: /* @__PURE__ */ new Date() }, u), { context: v, integrations: e }), d), g = "ajs-next-" + E.hash(JSON.stringify(f) + _()), h = t(t({}, f), { messageId: g });
      return h;
    }, p;
  }()
);
export {
  B as EventFactory
};
//# sourceMappingURL=index15.js.map
